var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "memo",
    clipPath: "url(#clip0_127_38516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M0.0234375 4C0.0234375 1.79375 1.81719 0 4.02344 0H20.0234C22.2297 0 24.0234 1.79375 24.0234 4V28C24.0234 30.2062 22.2297 32 20.0234 32H4.02344C1.81719 32 0.0234375 30.2062 0.0234375 28V4ZM4.02344 9C4.02344 9.55 4.47344 10 5.02344 10H19.0234C19.5734 10 20.0234 9.55 20.0234 9C20.0234 8.45 19.5734 8 19.0234 8H5.02344C4.47344 8 4.02344 8.45 4.02344 9ZM5.02344 14C4.47344 14 4.02344 14.45 4.02344 15C4.02344 15.55 4.47344 16 5.02344 16H19.0234C19.5734 16 20.0234 15.55 20.0234 15C20.0234 14.45 19.5734 14 19.0234 14H5.02344ZM5.02344 20C4.47344 20 4.02344 20.45 4.02344 21C4.02344 21.55 4.47344 22 5.02344 22H13.0234C13.5734 22 14.0234 21.55 14.0234 21C14.0234 20.45 13.5734 20 13.0234 20H5.02344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_38516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white",
    transform: "translate(0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemo);
export default __webpack_public_path__ + "static/media/memo.3a04c81c5eedade15626912165aaee6d.svg";
export { ForwardRef as ReactComponent };